import { render, staticRenderFns } from "./IndexPages.vue?vue&type=template&id=0e3bc2a5&scoped=true&"
import script from "./IndexPages.vue?vue&type=script&lang=js&"
export * from "./IndexPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3bc2a5",
  null
  
)

export default component.exports